import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { CopyField } from '@europrocurement/flexy-components';

export type ClipboardLineProps = {
    label: string;
    value?: ReactNode;
    overridedValue?: string;
};

const ClipboardLine: React.FunctionComponent<ClipboardLineProps> = function ({
    label,
    value,
    overridedValue,
}) {
    const displayValue = value && value !== '' ? value : null;

    const copyValue = (() => {
        if (value && typeof value === 'string' && value !== '') return value;
        if (overridedValue && overridedValue !== '') return overridedValue;
        return undefined;
    })();

    const wrapper = {
        display: 'flex',
        alignItems: 'center',
        width: '50%',
    };

    return (
        <Box display="flex">
            <Typography sx={{ ...wrapper, opacity: 0.7 }}>{label}</Typography>
            <Box sx={wrapper}>
                <CopyField
                    value={<Typography sx={{ fontSize: '16px' }}>{displayValue ?? '-'}</Typography>}
                    copyValue={copyValue}
                    alwaysShowCopy
                />
            </Box>
        </Box>
    );
};

export default ClipboardLine;
